import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useEffect } from 'react';
import { unregister } from '../service-worker-registration.js';

interface ContextProps {
  reloadPage: () => void;
  updateAvailable: boolean;
}

const UpdateContext = createContext<ContextProps>({
  reloadPage: () => {},
  updateAvailable: false,
});

export const UpdateProvider: FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    // Learn more about service workers: https://bit.ly/CRA-PWA
    // register({ onUpdate: onUpdateAvailable });
    unregister();
  }, []);

  const value: ContextProps = {
    reloadPage: () => {},
    updateAvailable: false,
  };

  return (
    <UpdateContext.Provider value={value}>{children}</UpdateContext.Provider>
  );
};

export const useUpdate = (): ContextProps => {
  return useContext(UpdateContext);
};
